import {
	TIMELINE_SEARCH_TYPING,
	TIMELINE_SEARCH_SUCCESS,
	TIMELINE_SEARCH_ERROR,
	TIMELINE_SEARCH_UPDATE_DOCUMENT_PRIORITY,
	TIMELINE_SEARCH_CLEAR_CONCEPT_TARGET_TERMS,
	TIMELINE_SEARCH_ADD_CONCEPT_TARGET_TERMS,
	TIMELINE_SEARCH_UPDATE_DOCUMENT_DATE,
	TIMELINE_SET_SOURCE_FILTER,
	TIMELINE_SEARCH_DOCS_DATA_SUCCESS,
	TIMELINE_RESULTS_CLEAR,
	UPDATE_TIMELINE_METADATA,
	GET_TIMELINE_SEARCH_REQUEST,
	GET_TIMELINE_SEARCH_REQUEST_FAILED,
	GET_TIMELINE_SEARCH_REQUEST_CLEAR,
	GET_GRAPH_DATA_REQUEST,
	GET_GRAPH_DATA_REQUEST_SUCCESS,
	GET_GRAPH_DATA_REQUEST_FAILED,
	GET_GRAPH_DATA_REQUEST_CLEAR,
	GET_SAVED_DATE_RANGE_SUCCESS,
	GET_SAVED_DATE_RANGE_FAILED,
	GET_SAVED_DATE_RANGE_FAIL,
	GET_SAVED_DATE_RANGE_CLEAR,
	GET_SAVED_DATE_RANGE_NAME_CHECK_SUCCESS,
	GET_SAVED_DATE_RANGE_NAME_CHECK_FAIL,
} from "../types"

//cada reducer tiene su propio state
const initialState = {
	timelineResults: {
		count: 0,
		data: {},
	},
	error: null,
	loading: false,
	concept_target_terms: [],
	current_search: "",
	sourceFilter: {
		doc: true,
		xls: true,
		ppt: true,
		pdf: true,
		txt: true,
		email: true,
		fromDate: "",
		toDate: "",
	},
	timelineDocsData: [],
	graph: [],
	graphLoading: false,
	savedDateRange: [],
	isNameExist: false,
}
// eslint-disable-next-line
export default function (state = initialState, action) {
	switch (action.type) {
		case TIMELINE_SET_SOURCE_FILTER:
			return { ...state, sourceFilter: action.payload }

		case TIMELINE_SEARCH_ADD_CONCEPT_TARGET_TERMS:
			//var auxTerms= state.concept_target_terms.concat(action.payload);
			return {
				...state,
				//concept_target_terms: auxTerms
				concept_target_terms: action.payload.concat(state.concept_target_terms),
			}
		case TIMELINE_SEARCH_CLEAR_CONCEPT_TARGET_TERMS:
			return {
				...state,
				concept_target_terms: action.payload,
			}
		case TIMELINE_SEARCH_UPDATE_DOCUMENT_PRIORITY:
			try {
				if (state.timelineResults.count > 0) {
					let index = state.timelineResults.data.findIndex((data) => data.id === action.payload.id)
					let aux_concept_docs = state.timelineResults
					aux_concept_docs.data[index]["tags"] = action.payload.priority
					return {
						...state,
						timelineResults: aux_concept_docs,
					}
				}
			} catch (error) {
				return { ...state }
			}
		case TIMELINE_SEARCH_UPDATE_DOCUMENT_DATE:
			try {
				let index = state.timelineResults.data.findIndex((data) => data.id === action.payload.id)
				let aux_concept_docs = state.timelineResults
				aux_concept_docs.data[index]["tagged_date"] = action.payload.date
				return { ...state, timelineResults: aux_concept_docs }
			} catch (error) {
				return { ...state }
			}

		case TIMELINE_SEARCH_TYPING:
			return {
				...state,
				loading: action.payload,
			}
		case TIMELINE_SEARCH_SUCCESS:
			return {
				...state,
				loading: false,
				timelineResults: {
					id_search: action.payload.conceptData.id,
					count: action.payload.conceptData.data.count,
					data: action.payload.responseDocsData,
				},
				current_search: action.payload.conceptData.id,
			}
		case UPDATE_TIMELINE_METADATA:
			const payload = action.payload
			const currentData = { ...state.timelineResults }
			const iIndex = Array.isArray(currentData.data) ? currentData.data.findIndex((data) => data.id === payload.id) : -1 //find the id
			if (iIndex !== -1) {
				let updateRecord = currentData.data[iIndex] //get the object
				updateRecord = { ...updateRecord, ...payload.data } //update the object
				currentData.data[iIndex] = updateRecord //assign bakc to list
			}
			return {
				...state,
				timelineResults: currentData,
			}
		case TIMELINE_RESULTS_CLEAR:
			return {
				...state,
				loading: false,
				timelineResults: {
					id_search: "",
					count: 0,
					data: [],
				},
			}
		case TIMELINE_SEARCH_ERROR:
			return {
				...state,
				loading: false,
				error: action.payload,
				current_search: "",
			}
		case TIMELINE_SEARCH_DOCS_DATA_SUCCESS:
			return {
				...state,
				timelineDocsData: action.payload,
			}

		case GET_TIMELINE_SEARCH_REQUEST:
			return {
				...state,
				allDocumentsLoading: true,
			}

		case GET_TIMELINE_SEARCH_REQUEST_FAILED:
			return {
				...state,
				loading: false,
				error: action.payload,
				current_search: "",
			}
		case GET_TIMELINE_SEARCH_REQUEST_CLEAR:
			return {
				...state,
				loading: false,
				timelineResults: {
					id_search: "",
					count: 0,
					data: [],
				},
			}
		case GET_GRAPH_DATA_REQUEST:
			return {
				...state,
				graphLoading: true,
				graph: [],
			}
		case GET_GRAPH_DATA_REQUEST_SUCCESS:
			return {
				...state,
				graphLoading: false,
				graph: action.payload,
			}
		case GET_GRAPH_DATA_REQUEST_FAILED:
			return {
				...state,
				graphLoading: false,
				error: action.payload,
				graph: [],
			}
		case GET_GRAPH_DATA_REQUEST_CLEAR:
			return {
				...state,
				error: undefined,
				graph: [],
			}
		case GET_SAVED_DATE_RANGE_SUCCESS:
			return {
				...state,
				savedDateRange: action.payload,
			}
		case GET_SAVED_DATE_RANGE_FAIL:
			return {
				...state,
			}
		case GET_SAVED_DATE_RANGE_CLEAR:
			return {
				...state,
				savedDateRange: [],
			}
		case GET_SAVED_DATE_RANGE_NAME_CHECK_SUCCESS:
			return {
				...state,
				isNameExist: action.payload,
			}
		case GET_SAVED_DATE_RANGE_NAME_CHECK_FAIL:
			return {
				...state,
				isNameExist: false,
			}

		default:
			return state
	}
}
